<template>
  <div class="hypervisor-sync-results">
    <div class="sync-filter-bar network-tabs-nav" data-sync-filter-target="#hypervisor-sync-table" role="tablist" aria-label="Sync diff filters">
      <button type="button" class="network-tab is-active" data-sync-diff-filter="all" aria-selected="true">All</button>
      <button type="button" class="network-tab" data-sync-diff-filter="SYNCED" aria-selected="false">SYNCED</button>
      <button type="button" class="network-tab" data-sync-diff-filter="MOVED" aria-selected="false">MOVED</button>
      <button type="button" class="network-tab" data-sync-diff-filter="MISMATCH" aria-selected="false">MISMATCH</button>
      <button type="button" class="network-tab" data-sync-diff-filter="NOT FOUND" aria-selected="false">NOT FOUND</button>
    </div>

    <table class="table table-striped table-bordered table-condensed" id="hypervisor-sync-table">
      <thead>
        <tr>
          <th><div class="text-center">OS</div></th>
          <th><div class="text-center">Name</div></th>
          <th><div class="text-center">Owner</div></th>
          <th><div class="text-center">Status in DB</div></th>
          <th><div class="text-center">Status in Actual</div></th>
          <th><div class="text-center">HyperVisor in DB</div></th>
          <th><div class="text-center">HyperVisor in Actual</div></th>
          <th><div class="text-center">Diff</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="`sync-${row.id}`" :data-sync-diff="row.diff_value">
          <td><img :src="row.os_icon_url" width="20" height="20" alt=""></td>
          <td>{{ row.name }}</td>
          <td>{{ row.owner }}</td>
          <td class="text-center"><span class="app-status-chip" :class="row.db_status_class">{{ row.db_status_label }}</span></td>
          <td class="text-center"><span class="app-status-chip" :class="row.actual_status_class">{{ row.actual_status_label }}</span></td>
          <td>{{ row.db_hv_name }}</td>
          <td>{{ row.actual_hv_name }}</td>
          <td class="text-center"><span class="app-status-chip" :class="row.diff_class">{{ row.diff_value }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ rows: [] })
  }
})

const rows = computed(() => props.initialData?.rows || [])
</script>
